import AnchorCollapses from "./components/AnchorCollapses";
import AnchorScroll from "./components/AnchorScroll";

const anchorCollapses = new AnchorCollapses( "denhaag-anchor-collapse" );
window.addEventListener( "DOMContentLoaded", () => {
  new AnchorScroll( "secondary-navigation" );

  anchorCollapses.initialize();
  anchorCollapses.setupEventListeners();
});
window.addEventListener( "dh:resize", () => anchorCollapses.resize() );
